import { apiClient, PASSWORD } from '../../../shared/api';

export const requestPasswordReset = async (email) => {
  const requestBody = {
    user: {
      email,
    },
  };

  await apiClient.post(PASSWORD, requestBody);
};

export const resetPassword = async ({ password, resetToken }) => {
  const requestBody = {
    user: {
      password,
      password_confirmation: password,
      reset_password_token: resetToken,
    },
  };

  await apiClient.put(PASSWORD, requestBody);
};
